import React, { Component } from 'react';
import { Button } from '@eg/elements/Button';
import { ComparisonTable } from '@eg/elements/ComparisonTable';
import { Price } from '@eg/elements/Price';
import { CheckIllustratedIcon } from '@eg/elements/Icons/CheckIllustratedIcon';
import { CheckIcon } from '@eg/elements/Icons/CheckIcon';
import { Benefit } from '@eg/elements/Benefit';
import { Details } from '@eg/elements/Details';
import { DownloadButton } from '@eg/elements/DownloadButton';
import { HouseGroundIcon } from '@eg/elements/Icons/HouseGroundIcon';
import { TooltipIcon } from '@eg/elements/TooltipIcon';
import { Card } from '@eg/elements/Card';

import "./ProductDetails.scss";
import "../shared/style/ergo-fonts.scss";

class ProductDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open:false,
      navMessage:'',
      advertiserID: '',
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount(){
    var urlANR = this.getUrlData('ANR');

    if(urlANR !== undefined) {
      this.setState({advertiserID: urlANR});
    }
  }

  getUrlData = (variable) => {
    var url = window.location.search.substring(1);
    var data = url.split("?");

    for (var i=0; i<data.length; i++) {
      var pair = data[i].split("=");
      if(pair[0] === variable) {
        return pair[1];
      }
    }
  }

  handleClick() {
    if(this.state.advertiserID !== undefined && this.state.advertiserID !== null && this.state.advertiserID !== '') {
      this.props.history.push("/internet-schutzbrief/tarifdaten?ANR=" + this.state.advertiserID);
    } else {
      this.props.history.push("/internet-schutzbrief/tarifdaten")
    }

    window.scrollTo(0, 0);
  }

  render() {
    return(
      <div id="outerDivStartPage">
        <section className="product-header esc_container">
          <div className="product-header_background full-width">
            <div className="product-header__wrapper esc_container esc_container--xxl">
              <div className="product-header_teaser">
                <h1 className="product-headline">Internetschutzbrief</h1>
                <p className="product-header_teaser-title">Ihr Sicherheitsnetz beim Online-Shopping</p>
                <div className="product-header_teaser-button">
                  <Button id="header-button" variant="primary" onClick={this.handleClick}>Online abschließen</Button>
                </div>
              </div>
              <div className="product-header__image">
                <img id="image" src={process.env.PUBLIC_URL + "/statics/images/Internet-Schutzbrief.jpg"} alt="" />
              </div>
            </div>
          </div>
        </section>
        <section className="esc_container esc_container--l">
          <div className="esc_container">
            <Card padding="normal">
              <Benefit icon={CheckIcon} label="Datendiebstahl">
                Bis zu 15.000,00 € Schutz bei Missbrauch Ihrer Konto- und Kundendaten.
              </Benefit>
              <Benefit icon={CheckIcon} label="Nichtlieferung">
                Bis zu 3.000,00 € Schutz, wenn online bestellte Ware nicht geliefert wird
              </Benefit>
              <Benefit icon={CheckIcon} label="Mehr finanzielle Sicherheit">
                Mehr finanzielle Sicherheit beim Online-Shopping und -Banking für Sie und Ihre Familie
              </Benefit>
            </Card>
          </div>
          <Card id="risks">
            <div className="esc_container" >
              <h3>Internet-Schutzbrief</h3>
              <p>
                Wer im Internet aktiv ist, setzt sich besonderen Risiken aus. Datendiebstahl und Betrug bedeuten oft hohe finanzielle Verluste. Schützen Sie sich jetzt mit unserem neuen Internet-Schutzbrief.
              </p>
            </div>
          </Card>
          <div className="esc_container" id="buttonAfterRisks">
            <Button variant="secondary" onClick={this.handleClick}>Online abschließen</Button>
          </div>
          <div className="esc_container" id="benefitDetails">
            <h3 id="headlineBenefitsOnOneSight">Alle Vorteile auf einen Blick</h3>
            <Details summary="Ihr Schutz bei Datendiebstahl"  isInitiallyOpen>
              Ob beim Online-Shopping, bei Newsletter-Anmeldungen oder Registrierungen zu Gewinnspielen ... im Internet werden ständig unsere persönlichen Daten abgefragt. Mal ehrlich, denken Sie nicht auch: „Datendiebstahl – mir passiert das nicht“? Im Falle eines Falles erstatten wir Ihnen bis zu 15.000,00 € bei Missbrauch Ihrer Konto- und Kundendaten.
            </Details>
            <Details summary="Ihre Bestellung wurde nicht geliefert?">
              Das kommt viel häufiger vor, als erwartet. Sie bestellen online und haben die Ware bezahlt, aber nicht erhalten. Profitieren Sie auch in diesem Fall von Ihrem Internet-Schutzbrief. Damit sichern Sie sich im Schadensfall bis zu 3.000,00 € Erstattungsbeitrag.
            </Details>
            <Details summary="Höhere finanzielle Sicherheit">
              Mit dem Internet-Schutzbrief profitieren Sie von vielen Pluspunkten. Sie sichern sich gegen verschiedene Risiken ab, die jeden betreffen können, der online viel aktiv ist: ob beim Shoppen, Internetbanking oder, oder, oder. Und das für nur einmalig 6,90 € im Jahr. Das rechnet sich auf alle Fälle.
            </Details>
          </div>
          <Card padding="normal" id="benefitTable">
            <div className="esc_container" >
              <h1>Ihre Leistungen im Überblick</h1>
              <ComparisonTable>
                <thead>
                  <tr>
                    <th scope="row" id="headingTable">Internet-Schutzbrief (ISB)</th>
                    <th scope="row"><HouseGroundIcon width={35} height={35}/></th>
                  </tr>
                </thead>
                <tbody>
                  <tr id="tableFirstRow">
                    <th scope="row" colSpan="1" id="cell-insurancesum ">Weltweiter Schutz vor finanziellen Verlusten bei Missbrauch von Kunden- bzw. Kontodaten</th>
                    <td id="insurance-sum"><strong>15.000 € <wbr />Gesamt<wbr />versicherungs<wbr />summe</strong></td>
                  </tr>
                  <tr>
                    <th scope="row" colSpan="1">z.B. durch Phishing, Pharming, Skimming und Hacking</th>
                    <td ><CheckIllustratedIcon width={30} height={30}/></td>
                  </tr>
                  <tr>
                    <th scope="row" colSpan="1">
                      Bei bargeldlosen Bezahlvorgängen
                      <TooltipIcon>
                        Darunter versteht man E-Payment wie PayPal sowie Mobile-Payment.
                      </TooltipIcon>
                    </th>
                    <td ><CheckIllustratedIcon width={30} height={30}/></td>
                  </tr>
                  <tr>
                    <th scope="row" colSpan="1">Beim Online- und E-Mail-Banking</th>
                    <td ><CheckIllustratedIcon width={30} height={30}/></td>
                  </tr>
                  <tr>
                    <th scope="row" colSpan="1">
                      <div>Bei Bonus<wbr />systemen und Online<wbr />gutscheinen</div>
                      <TooltipIcon>
                        Zu Bonussystemen zählen beispielsweise Payback oder WEB.Cent
                      </TooltipIcon>
                    </th>
                    <td >500 €</td>
                  </tr>
                  <tr>
                    <th scope="row" colSpan="1">
                      Nichtlieferung Online-Shopping
                      <TooltipIcon>
                        Die Ware muss von einem Verkäufer mit Geschäfts-/Wohnsitz
                        innerhalb der EU bestellt worden sein. Bei der Nichtlieferung Online-Shopping
                        gilt ein Selbstbehalt von 10 % des Kaufpreises mindestens 50 €.
                      </TooltipIcon>
                    </th>
                    <td >3.000 €</td>
                  </tr>
                  <tr>
                    <th scope="row" colSpan="1" id="lastHeadingTable">Für nur</th>
                    <td >
                      <div>
                        <Price  id="priceInTable" value={6.90} suffix="im Jahr" /><br />
                        <Button id="buttonTable" variant="primary" onClick={this.handleClick}>Online abschließen</Button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </ComparisonTable>
            </div>
          </Card>
          <div className="esc_container" id="downloadSectionLandingPage">
            <h2>Ihre Leistungen im Detail</h2>
            <DownloadButton id="downloadButtonStartpage" target="blank" href={process.env.PUBLIC_URL +'/statics/Vertragsunterlagen-ISB.pdf'} fileType="pdf" fileSize="0,5 MB">Informationsblatt Internet-Schutzbrief</DownloadButton>
          </div>
        </section>
      </div>
    )
  }
}

export default ProductDetails;
